import {isCommonValidatorsChanged, updateCommonFields} from "../../dynamic-field/default-control-updater";
import {FilterSelectFieldValidators} from "./filter-select.builder";
import {FieldConfig} from "../../dynamic-field/field.config";
import {ControlUpdater} from "../../dynamic-field/control-updater.type";

export const FilterSelectControlUpdater: ControlUpdater = (
    currentFieldConfig: FieldConfig<any>,
    updateFieldConfig: FieldConfig<any>,
    control
) => {
    updateCommonFields(currentFieldConfig, updateFieldConfig, control);

    if (isCommonValidatorsChanged(currentFieldConfig, updateFieldConfig)) {
        const updatedFieldConfig = {...currentFieldConfig, ...updateFieldConfig};

        const validators = FilterSelectFieldValidators(updatedFieldConfig);
        control.setValidators(validators);
        control.updateValueAndValidity({emitEvent: false});
        return;
    }
};
